import { z } from 'zod';
export const SecurityLevelSchema = z.enum(['safe', 'moderate', 'elevated', 'restricted']);
export const TrustLevelSchema = z.enum(['untrusted', 'basic', 'trusted', 'highly-trusted']);
export const EnvironmentSchema = z.enum(['development', 'staging', 'production', 'any']);
export const ToolPatternSchema = z.object({
    name: z.string(),
    pattern: z.string(),
    description: z.string(),
    securityLevel: SecurityLevelSchema,
    requiredTrustLevel: TrustLevelSchema,
    supportedEnvironments: z.array(EnvironmentSchema),
    restrictions: z.object({
        pathRestrictions: z.array(z.string()).optional(),
        timeoutMs: z.number().positive().optional(),
        requiresApproval: z.boolean().default(false),
    }).optional(),
});
export const ToolSubsetSchema = z.object({
    name: z.string(),
    description: z.string(),
    patterns: z.array(z.string()),
    inheritsFrom: z.array(z.string()).optional(),
    securityLevel: SecurityLevelSchema,
    metadata: z.object({
        purpose: z.string(),
        riskLevel: z.enum(['low', 'medium', 'high']),
        recommendedFor: z.array(z.string()).optional(),
    }).optional(),
});
export const PermissionRoleSchema = z.object({
    name: z.string(),
    description: z.string(),
    toolSubsets: z.array(z.string()),
    inheritsFrom: z.array(z.string()).optional(),
    restrictions: z.object({
        maxExecutionTime: z.number().positive().optional(),
        maxConcurrency: z.number().positive().optional(),
        maxCostUsd: z.number().positive().optional(),
        allowedEnvironments: z.array(EnvironmentSchema).optional(),
        requiresApproval: z.boolean().default(false),
    }).optional(),
    metadata: z.object({
        purpose: z.string(),
        trustLevel: TrustLevelSchema,
        auditLevel: z.enum(['none', 'basic', 'detailed']).default('basic'),
    }).optional(),
});
export const AgentPermissionConfigSchema = z.object({
    agentName: z.string(),
    permissionMode: z.enum(['acceptEdits', 'bypassPermissions', 'default', 'plan']).default('bypassPermissions'),
    roles: z.array(z.string()).optional(),
    allowedTools: z.array(z.string()).optional(),
    deniedTools: z.array(z.string()).optional(),
    restrictions: z.object({
        maxExecutionTime: z.number().positive().optional(),
        maxConcurrency: z.number().positive().optional(),
        maxCostUsd: z.number().positive().optional(),
        allowedEnvironments: z.array(EnvironmentSchema).optional(),
        pathRestrictions: z.array(z.string()).optional(),
    }).optional(),
    metadata: z.object({
        purpose: z.string().optional(),
        trustLevel: TrustLevelSchema.optional(),
        environment: EnvironmentSchema.optional(),
        lastUpdated: z.string().datetime().optional(),
    }).optional(),
});
export const ValidationIssueSchema = z.object({
    type: z.enum(['error', 'warning', 'suggestion']),
    message: z.string(),
    field: z.string().optional(),
    code: z.string().optional(),
});
export const PermissionValidationResultSchema = z.object({
    isValid: z.boolean(),
    issues: z.array(ValidationIssueSchema),
    resolvedTools: z.array(z.string()).optional(),
    effectivePermissions: z.object({
        allowedPatterns: z.array(z.string()),
        deniedPatterns: z.array(z.string()),
        permissionMode: z.string(),
        restrictions: z.any().optional(),
    }).optional(),
});
export const PermissionBuilderOptionsSchema = z.object({
    validateOnBuild: z.boolean().default(true),
    strictMode: z.boolean().default(false),
    environment: EnvironmentSchema.default('development'),
    trustLevel: TrustLevelSchema.default('basic'),
});
//# sourceMappingURL=tool-permission-contracts.js.map